var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:['icon-button', _vm.sizeClass],style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }